import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { isLuxLoyaltyEnabledInAgentHub } from 'agentHub/selectors/agentHubSelectors'

const getCanLoyaltyEnrollExistingUser = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => selectLoggedIn(state),
  (state: App.State) => state.loyalty.account,
  (
    loyaltyEnabled,
    isLoggedIn,
    loyaltyAccount,
  ): boolean => {
    if (!loyaltyEnabled || !isLoggedIn) return false
    if (loyaltyAccount.fetching || loyaltyAccount.error) return false
    if (isLuxLoyaltyEnabledInAgentHub) return false
    return !loyaltyAccount.data
  },
)

export default getCanLoyaltyEnrollExistingUser
